"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, core_1.createStyles)({
        popoverContent: {
            padding: '24px 24px 32px',
            minWidth: 360,
            maxWidth: 400,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'inherit',
        },
        anchor: {
            width: 'max-content',
            cursor: 'pointer',
            marginRight: 'auto',
        },
        header: {
            marginBottom: 32,
        },
        body: {
            display: 'grid',
            rowGap: 20,
            flexShrink: 1,
            overflowY: 'auto',
            maxHeight: 250,
            paddingRight: 8,
        },
    });
});
